import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import routes, { Route as RouteType } from "routes";

export default function QuestionnaireLayout() {
  const getRoutes = (routes: RouteType[]): any => {
    return routes.map((route: RouteType, key: number) => {
      if (route.layout === "/questionnaires") {
        return (
          <Route path={`/${route.path}`} element={route.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <div>
      <div className="content">
        <Routes>
          {getRoutes(routes)}
          <Route
            path="/"
            element={<Navigate to="/questionnaires" replace />}
          />
        </Routes>
      </div>
    </div>
  );
} 